module.exports = __webpack_public_path__ + "static/media/bg-5.df73d1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web/bg-5.png
// module id = 53
// module chunks = 3